import * as React from "react";
import { Component } from "react";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import { Divider } from "react-md";
import "./Footer.css";

class App extends Component {
  render() {
    return (
      <div className="Footer">
        <Card>
          <CardText className="Footer">
            <p>Подвальчик.</p>
            <p>
              Оно не просто бытие, а наличное бытие; взятое этимологически,
              Dasein означает бытие в каком-то месте; но представление о
              пространстве здесь не приложимо. Наличное бытие есть вообще по
              своему становлению бытие с некоторым небытием, так что это небытие
              принято в простое единство с бытием. Небытие, принятое в бытие
              таким образом, что конкретное целое имеет форму бытия,
              непосредственности, составляет определённость, как таковую.
            </p>
            <p>Грузите апельсины бочками.</p>
            <Divider />
            <p>&copy; сherocky 2019</p>
          </CardText>
        </Card>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/layout/footer/Footer.tsx